import { StrapiField } from "~/types";

export function useSpecialOrderFieldRules<
  K extends Record<string, string>,
  T extends StrapiField = StrapiField,
>(dictionary: Record<keyof K, T>) {
  return computed<Record<keyof K, string>>(() => {
    return Object.entries(dictionary).reduce(
      (dictionary, entry: [keyof K, T]) => {
        dictionary[entry[0]] = entry[1].required ? "required" : "";
        return dictionary;
      },
      {} as Record<keyof K, string>,
    );
  });
}
